import React, {useState} from "react";
import { MdOutlineArrowLeft } from "react-icons/md";
// import emailjs from "@emailjs/browser";

const Contact = () => {
  // const [alertMessage, setAlertMessage] = useState("");
  // const form = useRef();
  // const sendEmail = (e) => {
  //   e.preventDefault();

  //   emailjs
  //     .sendForm(
  //       "service_lx267no",
  //       "template_my2q3wf",
  //       form.current,
  //       "xSt8Y8CRZ5oAIC6gE"
  //     )
  //     .then(
  //       (result) => {
  //         console.log(result.text);
  //         setAlertMessage("Message sent successfully!");
  //       },
  //       (error) => {
  //         console.log(error.text);
  //         setAlertMessage("Failed to send Message. Please try again.");
  //       }
  //     );

  //   e.target.reset();
  // };
  return (
    <>
      <section class="text-gray-600 body-font">
        <div class="container px-5 py-12 mx-auto">
          <div class="flex flex-wrap w-full ">
            <div class="lg:w-1/2 w-full ">
              <h1 class="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">
                Book your Day
              </h1>
              <div class="h-1 w-20 bg-indigo-500 rounded"></div>
              <div className="flex  text-start">
                <MdOutlineArrowLeft className="lg:w-[25px] lg:h-[25px] " />
                <a href="/">
                  <p className="text-blue-700 ">Back</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="text-gray-600 body-font lg:mt-[-100px]">
        <div class="container px-5 py-24 mx-auto flex sm:flex-nowrap flex-wrap">
          <div class="lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
            <iframe
              width="100%"
              height="100%"
              class="absolute inset-0"
              frameborder="0"
              title="map"
              marginheight="0"
              marginwidth="0"
              scrolling="no"
              src="https://maps.google.com/maps?width=100%&amp;height=100%&amp;hl=en&amp;q=S.M cooks, yelahanka&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
            <div class="bg-white  mt-8  relative flex flex-wrap lg:py-6 py-8  rounded shadow-md">
              <div class="lg:w-1/2 w-56  px-6">
                <h2 class="title-font font-semibold text-gray-900 tracking-widest text-xs">
                  ADDRESS
                </h2>
                <p class="mt-1">
                  old town, No.1041, hosa beedi, Hosabeedhi, Gandhi Nagar,
                  Yelahanka, Bengaluru, Karnataka 560064
                </p>
              </div>
              <div class="lg:w-1/2 px-6 mt-4 lg:mt-0">
                <h2 class="title-font font-semibold text-gray-900 tracking-widest text-xs">
                  EMAIL
                </h2>
                <a class="text-indigo-500 leading-relaxed">
                  smcooks91@gmail.com
                </a>
                <h2 class="title-font font-semibold text-gray-900 tracking-widest text-xs mt-4">
                  PHONE
                </h2>
                <p class="leading-relaxed">8495919191</p>
              </div>
            </div>
          </div>
          <div class="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-8 mt-8 md:mt-0">
            <h2 class="text-gray-900 text-3xl mb-1 font-medium title-font">
              Book Your Day
            </h2>
            <p class="leading-relaxed mb-5 text-gray-600">
              Elevate Every Occasion with Exquisite Culinary Creations and
              Impeccable Service.
            </p>
            <form
              action="https://formspree.io/f/myyrjpla"
              method="POST"
              // ref={form}
              // onSubmit={sendEmail}
            >
              <div class="relative mb-4">
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Name"
                  required
                  class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div class="relative mb-4">
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  placeholder="Phone Number"
                  required
                  class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div class="relative mb-4">
                <input
                  type="date"
                  id="date"
                  name="date"
                  placeholder="Date of event"
                  required
                  class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div class="relative mb-4">
                <input
                  type="time"
                  id="time"
                  name="time"
                  placeholder="Time of event"
                  required
                  class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                />
              </div>
              <div class="relative mb-4">
                <textarea
                  id="item_list"
                  name="item_list"
                  placeholder="1. List food items here"
                  class="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 h-64 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                ></textarea>
              </div>
              <button class="text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg">
                Book Now
              </button>
              {/* <p class="text-xs text-gray-500 mt-3">
                Chicharrones blog helvetica normcore iceland tousled brook viral
                artisan.
              </p> */}
            </form>
            {/* {alertMessage && (
              <div className="text-green-500 text-center font-bold">
                {alertMessage}
              </div>
            )} */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
